import { HttpRequest, HttpMethod } from "./http";

class CouponProvider extends HttpRequest {

    CouponGet(params) {
        return this.request(HttpMethod.Get,`/api/v1/coupon/` + params.id );
    }

    CouponList(params) {
        return this.request(HttpMethod.Get,`/api/v1/coupon`, params);
    }

    CouponMember(params) {
        return this.request(HttpMethod.Get,`/api/v1/coupon/member`, params);
    }

    CouponListDetailAll(params) {
        return this.request(HttpMethod.Get,`/api/v1/coupon/all`, params);
    }

	CouponListDetail(params) {
        return this.request(HttpMethod.Get,`/api/v1/coupon/detail`, params);
    }

    CouponCreate(params) {
        return this.request(HttpMethod.Post, "/api/v1/coupon", params);
    }

	CouponUpdate(id,payload) {
		return this.request(HttpMethod.Put,`/api/v1/coupon/${id}`,payload );
	}

    CouponDelete(id) {
        return this.request(HttpMethod.Delete, `/api/v1/coupon/${id}`);
    }

    CouponGetDocument(params) {
		return this.request(HttpMethod.Get,`/api/v1/coupon/pdf` ,params);
	}
}

export default CouponProvider
